module.exports = "/_next/static/images/OgProtocols-39c12ee0246359ba830e6cb6ef0f99b0.png";